import React, { useState, useEffect } from 'react';
import "./HomePage.css";
import cacpl from "../../Assets/logos/CACPL.png";
import performance from "../../Assets/performance.png";
import hal from "../../Assets/logos/HAL.jpg";
import reliance from "../../Assets/logos/reliance.png";
import azimpremji from "../../Assets/logos/azimpremji-university.png";
import biocon from "../../Assets/logos/biocon.jpg";
import chalet from "../../Assets/logos/chalet.png";
import fiorano from "../../Assets/logos/fiorano.png";
import aquantis from "../../Assets/logos/honer-aquantis.png";
import ibc from "../../Assets/logos/ibc.png";
import samsung from "../../Assets/logos/samsung.png";
import thub from "../../Assets/logos/thub.png";
import collins from "../../Assets/logos/collins-aerospace.png";
// import companyLogo from "../../Assets/sblogo.png";
// import SBmanufacturer from "../../Assets/sound-barrier-manufacturer.webp";
import constructionImg from "../../Assets/scl-site.jpeg";
import oilgasProjects from "../../Assets/oil-gas-project.jpg";
import airports from "../../Assets/airports.jpg";
import hospitals from "../../Assets/hospitals.jpg";
import hotels from "../../Assets/hotels.jpg";
import trafficareas from "../../Assets/traffic-areas.jpg";
import roadrailProjocts from "../../Assets/road-rail-projects.jpg";
import sportsevents from "../../Assets/sports-events.jpg";
import generatorRoomProjects from "../../Assets/generator-rooms.jpg";
import sbindia from "../../Assets/sound-barrier-india.webp";
import HNavbar from "../../Components/Navbar/HNavbar";
import MFooter from "../../Components/Main-Footer/MFooter";
import SEO from '../../Components/SEO';

// // NOTE: Bootstrap is already loaded via CDN in your index.html
// // Font Awesome 4.7 is already loaded via CDN in your index.html
// // No extra npm installs needed — just copy this file + HomePage.css

const APPLICATIONS = [
    { title: "Construction Sites", img: constructionImg },
    { title: "Oil & Gas Projects", img: oilgasProjects },
    { title: "Airports", img: airports },
    { title: "Hospitals", img: hospitals },
    { title: "Hotels", img: hotels },
    { title: "Traffic Areas", img: trafficareas },
    { title: "Road & Rail Projects", img: roadrailProjocts },
    { title: "Sports Events", img: sportsevents },
    { title: "Generator Room Projects", img: generatorRoomProjects },
];



// Crop positions for the logos.jpeg sprite (661×626px, scaled to 330px wide)
// 3 cols × 5 rows, header ≈ 25px offset, each cell ≈ 110×58px at 0.5 scale
// Put logos.jpeg in your /public folder so it's served at /logos.jpeg
const COMPANY_LOGOS = [
    { name: "cacpl", logo: cacpl },
    { name: "Chalet", logo: chalet },
    { name: "HAL", logo: hal },
    { name: "Reliance", logo: reliance },
    { name: "Azimpremji", logo: azimpremji },
    { name: "Biocon", logo: biocon },
    { name: "Collins", logo: collins },
    { name: "Fiorano", logo: fiorano },
    { name: "Aquantis", logo: aquantis },
    { name: "IBC", logo: ibc },
    { name: "Samsung", logo: samsung },
    { name: "Thub", logo: thub },
];

const WHY_CHOOSE = [
    { icon: "fa fa-volume-up", title: "Superior Noise Reduction", desc: "Engineered to block and absorb unwanted noise effectively." },
    { icon: "fa fa-cloud", title: "Weather Resistant", desc: "Built to withstand harsh outdoor conditions." },
    { icon: "fa fa-th", title: "Modular Design", desc: "Easy to transport, install, relocate and reuse." },
    { icon: "fa fa-fire", title: "Fire Retardant", desc: "Manufactured using materials suitable for demanding sites." },
    { icon: "fa fa-bolt", title: "Quick Installation", desc: "Fast deployment with minimal equipment and manpower." },
    { icon: "fa fa-recycle", title: "Sustainable Solution", desc: "Reusable system reduces waste and project costs." },
];

const ABOUT_FEATURES = [
    { icon: "fa fa-headphones", title: "Acoustic Design Support" },
    { icon: "fa fa-building", title: "Manufacturing in India" },
    { icon: "fa fa-globe", title: "Global Acoustic Know-How" },
    { icon: "fa fa-check-square", title: "Quality Assurance" },
];

export default function HomePage() {
    const [showTopBtn, setShowTopBtn] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        };
        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);


    return (
        <>
            <SEO
                title="Noise Control & Sound Barrier Manufacturer"
                description="Leading noise control and sound barrier manufacturer offering acoustic barriers and industrial soundproofing solutions for commercial and infrastructure projects."
                canonical="https://www.soundbarrier.in/"
            />

            <HNavbar />
            {/* ===== HERO ===== */}
            <section className="sb-hero">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-xl-5">
                            <div className="hero-tag">Sound Barrier Systems</div>
                            <h1 className="hero-title">
                                <span className="orange">Built to Reduce Noise.</span><br />
                                Because Every Site Deserves Better Acoustics.
                            </h1>
                            <p className="hero-desc">
                                High performance temporary &amp; permanent sound barrier systems for
                                construction sites, industrial facilities, infrastructure projects
                                &amp; outdoor applications.
                            </p>

                            <div className="d-flex flex-wrap gap-3 my-3 feature-icons-row">
                                {[
                                    { icon: "fa fa-bar-chart", label: "High Noise Reduction" },
                                    { icon: "fa fa-cloud", label: "Weather Resistant" },
                                    { icon: "fa fa-bolt", label: "Fast Installation" },
                                    { icon: "fa fa-refresh", label: "Reusable System" },
                                    { icon: "fa fa-shield", label: "Suitable for Indoor & Outdoor" },
                                ].map((f) => (
                                    <div className="feature-icon-item" key={f.label}>
                                        <i className={f.icon}></i>
                                        <span>{f.label}</span>
                                    </div>
                                ))}
                            </div>

                            <div className="d-flex flex-wrap gap-2 mt-2">
                                <a href="/contactus" className="btn2 btn2-orange d-inline-flex align-items-center gap-2">
                                    REQUEST A QUOTE&nbsp;<i className="fa fa-arrow-right"></i>
                                </a>
                                <a
                                    href="https://www.soundbarrier.in/pdfs/SOUND%20BARRIER%20-%20Technical%20Data%20Sheet.pdf"
                                    className="btn2 btn2-outline-dark-sb d-inline-flex align-items-center gap-2"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    DOWNLOAD BROCHURE&nbsp;<i className="fa fa-download"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ===== TRUSTED BY ===== */}
            <section className="trusted-section">
                <div className="container">
                    <div className="row align-items-center">

                        {/* Left Content */}
                        <div className="col-lg-2 col-md-4">
                            <div className="trusted-content">
                                <div className="trusted-label">Trusted By<br />Industry Leaders</div>
                            </div>
                        </div>

                        {/* Right Logo Slider */}
                        <div className="col-lg-10 col-md-8">

                            <div className="logos">
                                <div className="logo_items">
                                    {[...COMPANY_LOGOS, ...COMPANY_LOGOS].map((company, index) => (
                                        <img
                                            key={index}
                                            src={company.logo}
                                            alt={company.name}
                                        />
                                    ))}
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </section>

            {/* ===== THREE COLUMNS ===== */}
            <section className="three-col-section">
                <div className="container">
                    <div className="row gy-4">

                        {/* Noise Challenge */}
                        <div className="col-lg-3">
                            <div className="section-heading">The Noise Challenge</div>
                            <p style={{ fontSize: "0.83rem", color: "#555", lineHeight: 1.6 }}>
                                Construction and industrial activities generate high levels of noise
                                that can disrupt communities and impact project progress.
                            </p>
                            <div className="mt-3 d-flex flex-column gap-1">
                                {["Community complaints", "Noise regulation compliance", "Project delays and restrictions", "Worker comfort and safety", "Environmental impact concerns"].map((item) => (
                                    <div className="challenge-item" key={item}>
                                        <i className="fa fa-check-circle"></i>
                                        <span>{item}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Tested Performance */}
                        <div className="col-lg-6">
                            <div className="performance-box">
                                <h3 className="text-center">
                                    Tested Performance<br />
                                    <small style={{ fontSize: "0.75rem", fontWeight: 400 }}>35 mm Sound Barrier System</small>
                                </h3>
                                {/* Performance diagram image — put performance.png in your /public folder */}
                                <div style={{ margin: "0 -1.5rem" }}>
                                    <img
                                        src={performance}
                                        alt="Sound barrier performance diagram"
                                        style={{ width: "100%", display: "block", objectFit: "cover" }}
                                    />
                                </div>
                                <div className="text-center mt-3">
                                    <a href="/" className="btn2 btn2-view-report d-inline-flex align-items-center gap-2">
                                        VIEW TEST REPORT&nbsp;<i className="fa fa-download"></i>
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* Why Choose */}
                        <div className="col-lg-3">
                            <div className="section-heading">Why Choose<br />Sound Barrier®?</div>
                            <div className="mt-3">
                                {WHY_CHOOSE.map((item) => (
                                    <div className="why-choose-item" key={item.title}>
                                        <div className="why-icon"><i className={item.icon}></i></div>
                                        <div>
                                            <div className="why-title">{item.title}</div>
                                            <div className="why-desc">{item.desc}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ===== HOW IT WORKS ===== */}
            <section className="how-it-works-section mt-3">
                <div className="container">
                    <div className="section-heading" style={{ fontSize: "1.3rem", paddingLeft: "10px" }}>How It Works</div>
                    <p style={{ fontSize: "0.87rem", color: "var(--sb-orange)", lineHeight: 1.7, maxWidth: 460, paddingLeft: "10px" }}>
                        Acoustic Science Behind the Design
                    </p>
                    <div className="row gy-5 align-items-start">
                        <div className="col-lg-6">
                            <div className="section-heading" style={{ fontSize: "1.1rem", display: "flex", alignItems: "center", gap: "0.6rem" }}>
                                <i className="fa fa-check-circle" style={{ color: "var(--sb-orange)", fontSize: "1rem" }}></i>
                                <span>Sound Insulation (Blocking via Mass Law)</span>
                            </div>
                            <p style={{ fontSize: "0.87rem", color: "#555", lineHeight: 1.7, maxWidth: 460, textAlign: "justify" }}>
                                The barrier incorporates a dense, mass-loaded core layered between weather-resistant membranes. This design follows the Mass Law Principle,
                                where increased surface density provides higher resistance to airborne sound transmission, particularly effective in reducing mid to high-frequency noise (e.g., 500–5000 Hz).
                            </p>
                            <p style={{ fontSize: "0.87rem", color: "#555", lineHeight: 1.7, maxWidth: 460, textAlign: "justify" }}>
                                Lab-tested STC rating: 19
                            </p>
                            <p style={{ fontSize: "0.87rem", color: "#555", lineHeight: 1.7, maxWidth: 460, textAlign: "justify" }}>
                                Reduction: Up to 51 dB at 5000 Hz
                            </p>

                            <div className="section-heading" style={{ fontSize: "1.1rem", display: "flex", alignItems: "center", gap: "0.6rem" }}>
                                <i className="fa fa-check-circle" style={{ color: "var(--sb-orange)", fontSize: "1rem" }}></i>
                                <span>Sound Absorption (Dissipation of Acoustic Energy)</span>
                            </div>
                            <p style={{ fontSize: "0.87rem", color: "#555", lineHeight: 1.7, maxWidth: 460, textAlign: "justify" }}>
                                Inside the barrier is a layer of acoustic infill, made of fibrous or porous material. This material acts as a dissipative medium, converting
                                incident sound energy into heat through friction. It reduces sound reflections in semi-reverberant spaces and improves speech intelligibility and comfort.
                            </p>
                        </div>

                        <div className="col-lg-6">
                            {/* <div className="col-lg-6 text-center">
                                <img
                                    src={SBmanufacturer}
                                    alt="Sound Barrier Manufacturer"
                                    className="img-fluid how-it-works-img"
                                />
                            </div> */}
                            <div className="section-heading" style={{ fontSize: "1.1rem", display: "flex", alignItems: "center", gap: "0.6rem" }}>
                                <i className="fa fa-check-circle" style={{ color: "var(--sb-orange)", fontSize: "1rem" }}></i>
                                <span>Sound Diffraction (Creating an Acoustic Shadow)</span>
                            </div>
                            <p style={{ fontSize: "0.87rem", color: "#555", lineHeight: 1.7, maxWidth: 460, textAlign: "justify" }}>
                                Positioned between the noise source and the receiver, the barrier forms a partial enclosure or a screen, interrupting the direct path of sound. According to Maekawa’s theory,
                                the degree of attenuation depends on the path difference (δ) between the direct sound line and the shortest path over the barrier.
                            </p>
                            <p style={{ fontSize: "0.87rem", color: "#555", lineHeight: 1.7, maxWidth: 460, textAlign: "justify" }}>
                                Greater path difference (δ) → Higher insertion loss
                            </p>
                            <p style={{ fontSize: "0.87rem", color: "#555", lineHeight: 1.7, maxWidth: 460, textAlign: "justify" }}>
                                High-frequency sounds (shorter wavelengths) are effectively blocked
                            </p>
                            <p style={{ fontSize: "0.87rem", color: "#555", lineHeight: 1.7, maxWidth: 460, textAlign: "justify" }}>
                                Low-frequency sounds are more likely to diffract around the edges
                            </p>
                            <p style={{ fontSize: "0.87rem", color: "#555", lineHeight: 1.7, maxWidth: 460, textAlign: "justify" }}>
                                In ideal outdoor conditions, the barrier can achieve up to 10–15 dBA reduction behind the panel.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* ===== product Features THREE COLUMNS ===== */}
            <section className="pfthree-col-section mt-5">
                <div className="container">
                    <div className="row gy-4">

                        {/* Noise Challenge */}
                        <div className="col-lg-3">
                            <div className="section-heading">product Features</div>
                            <div className="mt-5 d-flex flex-column gap-1">
                                {[
                                    "Noise reduction : Upto 51dB reduction (at 5000Hz)s",
                                    "Height : 2060mm",
                                    "Width : 1350mm",
                                    "Fire Retardancy : As per ASTM E84",
                                    "Water resistance : Water proof membrane and acoustic infill are used.",
                                    "Warranty : 2 years",
                                    "Colors : Multi colors available upon request",
                                    "Road safety : Multiple reflective bands"
                                ].map((item, index) => (
                                    <div
                                        key={item}
                                        className="challenge-item"
                                        style={{ marginBottom: index === 3 ? "30px" : "15px" }}
                                    >
                                        <i className="fa fa-check-circle"></i>
                                        <span>{item}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Tested Performance */}
                        <div className="col-lg-4">
                            <div className="feature-box">
                                <div>
                                    <img
                                        src={sbindia}
                                        alt="Sound barrier performance diagram"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Why Choose */}
                        <div className="col-lg-5">
                            <div className="section-heading">International Standards and Test Protocols</div>
                            <div className="mt-3 d-flex flex-column gap-1">
                                {["ISO 10140-2: Acoustics – Laboratory measurement of airborne sound insulation of building elements", "ISO 717-1: Rating of sound insulation in buildings and of building elements – Airborne sound insulation", "ISO 9613-2: Attenuation of sound during propagation outdoors – General method of calculation", "ISO 354: Measurement of sound absorption in a reverberation room", "ASTM E90: Standard Test Method for Laboratory Measurement of Airborne Sound Transmission Loss of Building Partitions", "ASTM E413: Classification for Rating Sound Insulation", "ASTM C423: Sound Absorption and Sound Absorption Coefficients by the Reverberation Room Method", "ASTM E84: Standard Test Method for Surface Burning Characteristics of Building Materials"].map((item) => (
                                    <div className="challenge-item" key={item}>
                                        <i className="fa fa-arrow-right"></i>
                                        <span>{item}</span>
                                    </div>
                                ))}
                            </div>

                            <div className="section-heading">Research Studies and Acoustic Engineering Models</div>
                            <div className="mt-3 d-flex flex-column gap-1">
                                {["Maekawa, Z. (1968). Noise Reduction by Screens, Applied Acoustics, Vol. 1, Issue 3.", "Kurze, U. J., & Anderson, G. S. (1971). Sound Propagation Outdoors. Applied Acoustics.", "Harris, Cyril M. (Ed.). (1991). Handbook of Acoustical Measurements and Noise Control, McGraw-Hill."].map((item) => (
                                    <div className="challenge-item" key={item}>
                                        <i className="fa fa-arrow-right"></i>
                                        <span>{item}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ===== APPLICATIONS ===== */}
            <section className="applications-section">
                <div className="container">
                    <div className="row align-items-center applications-row">
                        {/* Left Side */}
                        <div className="col-lg-6 order-2 order-lg-1">
                            <img
                                src={constructionImg}
                                alt="Applications"
                                className="applications-main-image"
                            />
                        </div>
                        {/* Right Side */}
                        <div className="col-lg-6 order-1 order-lg-2">
                            <div className="section-heading">
                                Applications
                            </div>

                            <p className="app-subtitle">
                                One Solution. Multiple Industries.
                            </p>

                            <p className="app-description">
                                Sound barriers are widely used to control and reduce noise
                                pollution across construction, industrial and commercial
                                environments while improving worker safety and surrounding
                                community comfort.
                            </p>

                            <div className="application-list">
                                {APPLICATIONS.map((item) => (
                                    <div className="challenge-item" key={item.title}>
                                        <i className="fa fa-check-circle"></i>
                                        <span>{item.title}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ===== ABOUT + PROJECT ===== */}
            <section className="about-section">
                <div className="container">
                    <div className="row gy-4 align-items-start">
                        <div className="col-lg-6">
                            <div className="section-heading" style={{ fontSize: "1.3rem" }}>About Acoustical Surfaces</div>
                            <p style={{ fontSize: "0.87rem", color: "#555", lineHeight: 1.7, maxWidth: 460 }}>
                                For over 40 years, we have delivered innovative acoustic solutions across commercial, industrial,
                                educational, hospitality and infrastructure projects in India and the GCC.
                            </p>
                            <div className="row g-3 mt-1">
                                {ABOUT_FEATURES.map((f) => (
                                    <div className="col-6" key={f.title}>
                                        <div className="about-feature">
                                            <i className={f.icon} style={{ color: "var(--sb-orange)", fontSize: "1.5rem", flexShrink: 0 }}></i>
                                            <span style={{ fontSize: "0.8rem", fontWeight: 600, color: "#333" }}>{f.title}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="project-box">
                                <div className="row align-items-center">
                                    <div className="col-md-8">
                                        <div className="section-heading" style={{ fontSize: "1.1rem" }}>Let's Discuss Your Project</div>
                                        <p style={{ fontSize: "0.85rem", color: "#666", lineHeight: 1.6 }}>
                                            Share your site drawing or project details and our acoustic experts will
                                            recommend the right Sound Barrier® solution for you.
                                        </p>
                                        <div className="d-flex flex-wrap gap-2 mt-3">
                                            <a href="/contactus" className="btn2 btn2-orange d-inline-flex align-items-center gap-2" style={{ fontSize: "0.8rem" }}>
                                                REQUEST CONSULTATION&nbsp;<i className="fa fa-arrow-right"></i>
                                            </a>
                                            <a href="/contactus" className="btn2 btn2-outline-dark-sb d-inline-flex align-items-center gap-2" style={{ fontSize: "0.8rem" }}>
                                                CONTACT OUR TEAM&nbsp;<i className="fa fa-arrow-right"></i>
                                            </a>
                                        </div>
                                    </div>
                                    <div className="col-md-4 d-none d-md-flex justify-content-center">
                                        <div style={{ width: 90, height: 110, background: "linear-gradient(135deg, #e84c1e22, #e84c1e44)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                            <i className="fa fa-id-badge" style={{ fontSize: "3rem", color: "var(--sb-orange)" }}></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {showTopBtn && (
                <button className='scroll-to-top'
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                > ↑ </button>
            )
            }
            <MFooter />
        </>
    );
}
